import React from 'react'
import {
    JsonFormsWrapper as BaseJsonFormsWrapper,
    AdvancedMapperTester,
} from '@thefront/configform'
import AdvancedMapperControl from './AdvancedMapper'

// Wraps configform's JsonFormsWrapper with AdvancedMapperControl pre-injected
// via extraRenderers. Lives here (not in configform) because AdvancedMapper
// pulls in final-form / mui-rff / react-final-form-* deps that cliconfigs
// shouldn't inherit. See the TODO in configform's JsonFormsWrapper for the
// follow-up plan to rewrite AdvancedMapper dependency-free and inline it.
export const JsonFormsWrapper = ({ extraRenderers = [], ...props }) => (
    <BaseJsonFormsWrapper
        {...props}
        extraRenderers={[
            { tester: AdvancedMapperTester, renderer: AdvancedMapperControl },
            ...extraRenderers,
        ]}
    />
)
